import { c as _c } from "react/compiler-runtime";
import type { SvgIconProps } from '@mui/material';
export const PlusIconWithDropShadow = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g filter="url(#a)"><path fill="#fff" fillOpacity={0.5} fillRule="evenodd" d="M18 28c7.732 0 14-6.268 14-14S25.732 0 18 0 4 6.268 4 14s6.268 14 14 14ZM16.833 6.125a1.458 1.458 0 0 1 2.917 0v6.708h6.708a1.458 1.458 0 0 1 0 2.917H19.75v6.708a1.458 1.458 0 1 1-2.917 0V15.75h-6.708a1.458 1.458 0 1 1 0-2.917h6.708V6.125Z" clipRule="evenodd" shapeRendering="crispEdges" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><filter id="a" width={36} height={36} x={0} y={0} colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse"><feFlood floodOpacity={0} result="BackgroundImageFix" /><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" /><feOffset dy={4} /><feGaussianBlur stdDeviation={2} /><feComposite in2="hardAlpha" operator="out" /><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" /><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_67_18041" /><feBlend in="SourceGraphic" in2="effect1_dropShadow_67_18041" result="shape" /></filter></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" width={36} height={36} fill="none" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};